import Layouts from '../../layouts/Layouts';
import TopicBanner from '../../Components/topicBanner/TopicBanner';
import SubscriptionBoxes from './subscriptionBoxes/SubscriptionBoxes';
import BenefitsOFMembership from './benefitsOFMembership/BenefitsOFMembership';
import TrustedUsers from './trustedUsers/TrustedUsers';
import FrequentlyAskedQues from './frequentlyAskedQues/FrequentlyAskedQues';
import bnrImg from '../../assets/images/png/topicbnr2.png';
import bnrInnerImg from '../../assets/images/png/topicbanner-img3.png';

function SubscriptionPage() {
  return (
    <Layouts>
      <section className="subscriptionPage">
        <TopicBanner
          bgImg={bnrImg}
          img={bnrInnerImg}
          colorHeading="Healthcare plans"
          title="for you & your family"
          desc="Become your best self. Discover new ways to live an inspiring life through natural beauty, nutrition and diet, an active lifestyle, and better relationships."
        />
        <SubscriptionBoxes />
        <TrustedUsers />
        <BenefitsOFMembership />
        <FrequentlyAskedQues />
      </section>
    </Layouts>
  );
}

export default SubscriptionPage;
